<template>
  <div>
    <filtros class="w-mt"/>
  </div>
</template>

<script>
import serviceAliquotas from "../services/serviceAliquotas.js";
import filtros from "../components/filtros.vue";

export default {
  components: {
    filtros
  },

  data() {
    return {
      exibeFormulario: true
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w-mt {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/screens/Difal.vue